import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { Form, Formik } from "formik";
import { useState } from "react";
import { ContentStyle, DRxInputStyle, LgCardStyle } from "../../Theme";
import * as yup from "yup";
import YupPassword from "yup-password";
import DRxInput from "../../uikit/DRxInput";
import { YSButton } from "../../uikit/YSButton";
import HidePasswordIcon from "../../images/icons/HidePasswordIcon.svg";
import ShowPasswordIcon from "../../images/icons/ShowPasswordIcon.svg";
import {
  ChangeLoginPassword,
  UpdateLoginPassword,
} from "../../Apis/AuthApiServices";
import YSSnackBar from "../../uikit/YSSnackBar";
import { useNavigate } from "react-router";
YupPassword(yup);

export default function ChangePassword(props: any) {
  const navigate = useNavigate();
  const [showPass, setShowPass] = useState(false);
  const [showNewPass, setShowNewPass] = useState(false);
  const [updateState, setUpdateState] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });

  const UpdatePassword = async (
    { oldPassword, newPassword, confirmationPassword }: any,
    resetForm: any
  ) => {
    try {
      const LoginUserId = localStorage.getItem("LoginUserID");
      const bodyData = {
        oldPassword: oldPassword,
        newPassword: newPassword,
        confirmationPassword: confirmationPassword,
        userId: LoginUserId,
      };
      const result = props.changePass
        ? await ChangeLoginPassword(bodyData)
        : await UpdateLoginPassword(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        setUpdateState((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });
        if (props.changePass) {
          setTimeout(() => {
            navigate("/");
          }, 2000);
        } else {
          resetForm();
        }
      } else {
        setUpdateState((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (err) {
      setUpdateState((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Some Time!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  // const TOKEN = Cookies.get("JWT_TOKEN");
  // const agree = localStorage.getItem("termsAgree") ?? undefined;
  // useEffect(() => {
  //   if (TOKEN !== undefined && agree == "false") {
  //     navigate("/patientsearch", { replace: true });
  //   }
  // }, [TOKEN]);
  return (
    <ContentStyle style={{ height: props.changePass && "100vh" }}>
      <Grid
        container
        item
        xs={12}
        spacing={3}
        alignItems="center"
        justifyContent="center"
      >
        <Grid item xs={12}>
          <Formik
            initialValues={{
              oldPassword: "",
              newPassword: "",
              confirmationPassword: "",
            }}
            validationSchema={yup.object().shape({
              oldPassword: yup
                .string()
                .required("Old Password is Required")
                .min(8),
              newPassword: yup
                .string()
                .minLowercase(1, "Must Contain 1 Lowercase")
                .minUppercase(1, "Must Contain 1 Uppercase")
                .minSymbols(1, "Must Contain 1 Symbol")
                .minNumbers(1, "Must Contain 1 Number")
                .required("New Password is Required")
                .min(8),
              confirmationPassword: yup
                .string()
                .minLowercase(1, "Must Contain 1 Lowercase")
                .minUppercase(1, "Must Contain 1 Uppercase")
                .minSymbols(1, "Must Contain 1 Symbol")
                .minNumbers(1, "Must Contain 1 Number")
                .min(8)
                .required("Confirm New Password is Required")
                .oneOf([yup.ref("newPassword"), null], "Passwords must match"),
            })}
            onSubmit={(values, { resetForm }) => {
              UpdatePassword(values, resetForm);
            }}
          >
            {(registerProps) => (
              <Form onSubmit={registerProps.handleSubmit}>
                {" "}
                <Grid
                  container
                  item
                  xs={12}
                  spacing={2}
                  alignItems="center"
                  justifyContent="center"
                >
                  <Grid item xs={12} md={8}>
                    <LgCardStyle style={{ padding: 30, borderRadius: 10 }}>
                      <Grid
                        container
                        item
                        xs={12}
                        spacing={2}
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Grid item xs={12}>
                          <Typography
                            component="h6"
                            color="primary"
                            variant="h6"
                            textAlign={"center"}
                            marginBottom={0}
                          >
                            {props.changePass
                              ? "Password has expired. Please change the password"
                              : "Update Password"}
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography
                            component="h6"
                            variant="subtitle1"
                            textAlign={"center"}
                            marginBottom={0}
                          >
                            {props.changePass &&
                              localStorage.getItem("LoginUserID")}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={7}>
                          <DRxInputStyle className="pwd">
                            <DRxInput
                              id="OldPassword"
                              name="oldPassword"
                              type={showPass ? "text" : "password"}
                              className="input"
                              disabled={false}
                              placeholder={"Enter Old Password"}
                            />
                            <IconButton
                              className="eye"
                              onClick={() => {
                                setShowPass(!showPass);
                              }}
                            >
                              {showPass ? (
                                <img
                                  src={ShowPasswordIcon}
                                  alt="Show Password"
                                  loading="lazy"
                                />
                              ) : (
                                <img
                                  src={HidePasswordIcon}
                                  alt="Hide Password"
                                  loading="lazy"
                                />
                              )}
                            </IconButton>
                          </DRxInputStyle>
                        </Grid>
                        <Grid item md={7} xs={12}>
                          <DRxInputStyle className="pwd">
                            <DRxInput
                              id="EnterNewPassword"
                              name="newPassword"
                              type={showNewPass ? "text" : "password"}
                              className="input"
                              disabled={false}
                              placeholder={"Enter New Password"}
                            />
                            <IconButton
                              className="eye"
                              onClick={() => {
                                setShowNewPass(!showNewPass);
                              }}
                            >
                              {showNewPass ? (
                                <img
                                  src={ShowPasswordIcon}
                                  alt="Show Password"
                                  loading="lazy"
                                />
                              ) : (
                                <img
                                  src={HidePasswordIcon}
                                  alt="Hide Password"
                                  loading="lazy"
                                />
                              )}
                            </IconButton>
                          </DRxInputStyle>
                        </Grid>
                        <Grid item md={7} xs={12}>
                          <DRxInputStyle className="pwd">
                            <DRxInput
                              id="confirm"
                              name="confirmationPassword"
                              type={"text"}
                              className="input"
                              disabled={false}
                              placeholder={"Confirm New Password"}
                            />
                          </DRxInputStyle>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography
                            variant="body2"
                            component="div"
                            textAlign={"center"}
                          >
                            Set a password of at least 8 characters with letters
                            and numbers
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={6} textAlign="center">
                          <YSButton
                            onClick={null}
                            className=""
                            children={props.changePass ? "Change" : "Update"}
                            size={"large"}
                            type="submit"
                            color="primary"
                            variant="contained"
                          />
                        </Grid>
                        {props.changePass && (
                          <Grid item xs={12} md={6} textAlign="center">
                            <YSButton
                              onClick={() => {
                                navigate("/");
                              }}
                              className=""
                              children={"Cancel"}
                              size={"large"}
                              type="button"
                              color="primary"
                              variant="contained"
                            />
                          </Grid>
                        )}
                      </Grid>
                    </LgCardStyle>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </Grid>
      </Grid>
      <YSSnackBar
        message={updateState.message}
        variant={updateState.variant}
        open={updateState.open}
        handleClose={() => {
          setUpdateState((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </ContentStyle>
  );
}
